import {API} from "@/api/generated";
import {ComponentPublicInstance} from "vue";

function getErrorContext(info: string): string {
  if (!info) {
    return "Неизвестная ошибка в жизненном цикле компонента.";
  }
  const infoMap: {[key: string]: string} = {
    1: "Ошибка во время рендеринга компонента.",
    2: "Ошибка при вычислении реактивных свойств (computed или watch).",
    3: "Ошибка при монтировании компонента (mounted).",
    4: "Ошибка при обновлении компонента (updated).",
    5: "Ошибка при обновлении данных компонента.",
    6: "Ошибка в beforeCreate.",
    7: "Ошибка в created.",
    8: "Ошибка в beforeMount.",
    9: "Ошибка в mounted.",
    10: "Ошибка в beforeUpdate.",
    11: "Ошибка в updated.",
    12: "Ошибка в beforeDestroy.",
    13: "Ошибка в destroyed."
  };

  return infoMap[info] || info;
}
async function getEmailUser(): Promise<string> {
  const user = await API.getUser();
  return user?.email ?? "";
}

export const getErr = async (
  err: unknown,
  instance: ComponentPublicInstance | null,
  info: string
): Promise<void> => {
  const Err = err as Error;
  // Отправка ошибки на сервер
  await API.sendError({
    body: {
      errMessage: Err.message || "Неизвестная ошибка",
      errStack: Err.stack || "Стек ошибок недоступен",
      errName: Err.name || "Неизвестный тип ошибки",
      time: new Date().toISOString(),
      url: window.location.href.split("?")[0],
      email: await getEmailUser(),
      component: instance?.$options?.name || "Неизвестный компонент",
      info: getErrorContext(info)
    }
  });
};
